var map = {
	"./1.jpg": "e1c4",
	"./2.jpg": "0c6a",
	"./3.jpg": "7ac6",
	"./4.jpg": "39fb",
	"./5.jpg": "b5bc",
	"./6.jpg": "af29",
	"./7.jpg": "ea4e",
	"./8.jpg": "5df4",
	"./9.jpg": "d37b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d8d8";